import Cookies from 'js-cookie'

const TokenKey = 'satoken'

const Role = 'role'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRole() {
  return Cookies.get(Role)
}

export function setRole(role) {
  return Cookies.set(Role, role)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js